module.exports = __webpack_public_path__ + "img/artillery-wagon-base-3.bf54d74d.png";